/* Kokoro - rewards progress bar + native free gifts (tiers with one or more options).
   Config comes from the 'Kokoro cart settings' section (header group).
   Gift lines carry the hidden line property _kk_gift so a gift can be told apart
   from the same product bought at full price.
   Works with any add-to-cart source: Dawn events, page builders, plain forms. */
(function () {
  var cfgEl = document.getElementById('kk-cart-config');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var gifts = (cfg.gifts || []).map(function (g) {
    g.options = (g.options || []).filter(function (o) { return o && o.variantId; });
    return g;
  });
  var giftIds = [];
  gifts.forEach(function (g) { g.options.forEach(function (o) { giftIds.push(o.variantId); }); });

  var lastPct = 0;
  var syncing = false;
  var lastCart = null;
  var timer = null;
  var nativeFetch = window.fetch.bind(window);

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }

  function money(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cfg.currency || 'EUR' }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function shipThreshold() {
    var found = null;
    String(cfg.thresholds || '').split(',').forEach(function (pair) {
      var kv = pair.split(':');
      if (kv.length === 2 && kv[0].trim().toUpperCase() === cfg.country) {
        var v = Math.round(parseFloat(kv[1]) * 100);
        if (v > 0) found = v;
      }
    });
    return found;
  }

  function milestones() {
    var list = [];
    var s = shipThreshold();
    if (s) list.push({ at: s, label: cfg.texts.shipping, icon: '🚚' });
    gifts.forEach(function (g) {
      if (g.threshold > 100 && g.label) list.push({ at: g.threshold, label: g.label, icon: g.icon || '🎁' });
    });
    list.sort(function (a, b) { return a.at - b.at; });
    var merged = [];
    list.forEach(function (m) {
      var prev = merged[merged.length - 1];
      if (prev && prev.at === m.at) prev.label += ' + ' + m.label;
      else merged.push({ at: m.at, label: m.label, icon: m.icon });
    });
    return merged;
  }

  /* ---------- gift helpers ---------- */
  function isGiftLine(item) {
    return !!(item && item.properties && item.properties._kk_gift === '1');
  }
  function declined() {
    try { return JSON.parse(sessionStorage.getItem('kkGiftDeclined') || '[]'); } catch (e) { return []; }
  }
  function setDeclined(list) {
    try { sessionStorage.setItem('kkGiftDeclined', JSON.stringify(list)); } catch (e) {}
  }
  function tierDeclined(g) {
    var d = declined();
    return g.options.some(function (o) { return d.indexOf(o.variantId) > -1; });
  }
  function savedOption(g) {
    var saved = null;
    try { saved = parseInt(localStorage.getItem('kkGiftChoice_' + g.threshold), 10); } catch (e) {}
    return g.options.filter(function (o) { return o.available && o.variantId === saved; })[0] || null;
  }
  function firstAvailable(g) {
    return g.options.filter(function (o) { return o.available; })[0] || null;
  }
  function linesFor(g, cart) {
    return cart.items.filter(function (i) {
      return isGiftLine(i) && g.options.some(function (o) { return o.variantId === i.variant_id; });
    });
  }

  /* gift rows in Dawn's cart markup: hide the quantity selector */
  function markGiftRows() {
    if (!lastCart) return;
    lastCart.items.forEach(function (item, idx) {
      if (!isGiftLine(item)) return;
      var n = idx + 1;
      document.querySelectorAll('#CartDrawer-Item-' + n + ', #CartItem-' + n).forEach(function (row) {
        row.classList.add('kk-gift-row');
      });
    });
  }

  function chooserHTML(total) {
    if (!cfg.nativeGifts || !lastCart || total <= 0) return '';
    var html = '';
    gifts.forEach(function (g) {
      if (g.options.length < 2 || total < g.threshold) return;
      var lines = linesFor(g, lastCart);
      var current = lines.length ? lines[0].variant_id : null;
      html += '<div class="kk-cp__choice"><p class="kk-cp__choice-t">' + esc(g.choiceLabel || 'Choose your free gift') + '</p><div class="kk-cp__opts">';
      g.options.forEach(function (o) {
        var on = o.variantId === current;
        html += '<button type="button" class="kk-cp__opt' + (on ? ' is-on' : '') + '" data-kk-gift-choice="' + o.variantId + '" data-kk-tier="' + g.threshold + '" aria-pressed="' + on + '"' + (o.available ? '' : ' disabled') + '>' +
          (o.image ? '<img src="' + esc(o.image) + '" alt="" width="40" height="40" loading="lazy">' : '') +
          '<span>' + esc(o.title) + '</span></button>';
      });
      html += '</div></div>';
    });
    return html;
  }

  /* ---------- progress bar ---------- */
  function render(el, total) {
    var ms = milestones();
    if (!cfg.progress || !ms.length) { el.innerHTML = ''; return; }
    var max = ms[ms.length - 1].at;
    var pct = Math.max(0, Math.min(100, (total / max) * 100));
    var next = null;
    for (var i = 0; i < ms.length; i++) { if (total < ms[i].at) { next = ms[i]; break; } }

    var msg = next
      ? esc(cfg.texts.away).replace('[amount]', '<b>' + money(next.at - total) + '</b>').replace('[reward]', esc(next.label))
      : esc(cfg.texts.done) + ' 🎉';

    var dots = ms.map(function (m) {
      var left = Math.min(100, (m.at / max) * 100);
      return '<span class="kk-cp__dot' + (total >= m.at ? ' is-on' : '') + '" style="left:' + left + '%" aria-hidden="true">' + esc(m.icon) + '</span>';
    }).join('');

    var items = ms.map(function (m) {
      return '<li class="' + (total >= m.at ? 'is-on' : '') + '"><span>' + money(m.at) + '</span><span>·</span><span>' + esc(m.label) + '</span></li>';
    }).join('');

    el.innerHTML =
      '<div class="kk-cp__msg" role="status">' + msg + '</div>' +
      '<div class="kk-cp__track"><div class="kk-cp__fill" style="width:' + lastPct + '%"></div>' + dots + '</div>' +
      '<ul class="kk-cp__list" role="list">' + items + '</ul>' +
      chooserHTML(total);

    var fill = el.querySelector('.kk-cp__fill');
    setTimeout(function () { fill.style.width = pct + '%'; }, 30);
    lastPct = pct;
  }

  if (!customElements.get('kk-cart-progress')) {
    customElements.define('kk-cart-progress', class extends HTMLElement {
      connectedCallback() { render(this, parseInt(this.dataset.total || '0', 10) || 0); }
    });
  }

  function updateAll(total) {
    document.querySelectorAll('kk-cart-progress').forEach(function (el) {
      el.dataset.total = total;
      render(el, total);
    });
    markGiftRows();
  }

  /* ---------- cart requests (always through the untouched native fetch) ---------- */
  function fetchCart() {
    return nativeFetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function post(path, body) {
    return nativeFetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error('cart request failed'); return r.json(); });
  }

  function refreshUI() {
    var path = location.pathname.replace(/\/$/, '');
    if (path.slice(-5) === '/cart') {
      /* never reload more than twice in a row: a line Shopify refuses to change must not trap the page */
      var n = 0;
      try { n = parseInt(sessionStorage.getItem('kkReloads') || '0', 10) || 0; } catch (e) {}
      if (n >= 2) return Promise.resolve();
      try { sessionStorage.setItem('kkReloads', String(n + 1)); } catch (e) {}
      location.reload();
      return Promise.resolve();
    }
    return nativeFetch(root + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var parser = new DOMParser();
        var drawerDoc = parser.parseFromString(sections['cart-drawer'] || '', 'text/html');
        var src = drawerDoc.querySelector('#CartDrawer');
        var dst = document.querySelector('#CartDrawer');
        var drawer = document.querySelector('cart-drawer');
        if (src && dst && drawer) {
          dst.innerHTML = src.innerHTML;
          drawer.classList.toggle('is-empty', !!drawerDoc.querySelector('cart-drawer.is-empty'));
          var overlay = drawer.querySelector('#CartDrawer-Overlay');
          if (overlay && drawer.close) overlay.addEventListener('click', drawer.close.bind(drawer));
        }
        var bubbleDoc = parser.parseFromString(sections['cart-icon-bubble'] || '', 'text/html');
        var bubbleSrc = bubbleDoc.querySelector('.shopify-section');
        var bubbleDst = document.getElementById('cart-icon-bubble');
        if (bubbleSrc && bubbleDst) bubbleDst.innerHTML = bubbleSrc.innerHTML;
      })
      .catch(function () {});
  }

  /* ---------- native free gifts ---------- */
  function sync(cart) {
    if (!cfg.nativeGifts || syncing || !giftIds.length) return Promise.resolve(false);
    /* threshold is based on what the customer actually pays for: gift lines never count */
    var base = cart.items.reduce(function (sum, item) {
      return isGiftLine(item) ? sum : sum + item.final_line_price;
    }, 0);
    var adds = [];
    var updates = {};

    /* gift lines from an older setup (product no longer a configured gift) are removed:
       an unpublished or archived gift product would otherwise block checkout */
    cart.items.forEach(function (item) {
      if (isGiftLine(item) && giftIds.indexOf(item.variant_id) < 0) updates[item.key] = 0;
    });

    gifts.forEach(function (g) {
      if (!g.options.length) return;
      var lines = linesFor(g, cart);
      var earned = base > 0 && base >= g.threshold;

      if (!earned) {
        lines.forEach(function (l) { updates[l.key] = 0; });
        return;
      }

      var want = savedOption(g);
      if (!lines.length) {
        var pick = want || firstAvailable(g);
        if (pick && !tierDeclined(g)) adds.push({ id: pick.variantId, quantity: 1, properties: { _kk_gift: '1' } });
      } else if (want && !lines.some(function (l) { return l.variant_id === want.variantId; })) {
        lines.forEach(function (l) { updates[l.key] = 0; });
        adds.push({ id: want.variantId, quantity: 1, properties: { _kk_gift: '1' } });
      } else {
        var keep = want ? want.variantId : lines[0].variant_id;
        lines.forEach(function (l) {
          if (l.variant_id !== keep) updates[l.key] = 0;
          else if (l.quantity > 1) updates[l.key] = 1;
        });
      }
    });

    if (!adds.length && !Object.keys(updates).length) return Promise.resolve(false);

    syncing = true;
    var chain = Promise.resolve();
    if (Object.keys(updates).length) chain = chain.then(function () { return post('cart/update.js', { updates: updates }); });
    if (adds.length) chain = chain.then(function () { return post('cart/add.js', { items: adds }); });
    return chain
      .then(refreshUI)
      .catch(function () {})
      .then(function () { syncing = false; return true; });
  }

  function onCartChange() {
    return fetchCart()
      .then(function (cart) {
        lastCart = cart;
        return sync(cart).then(function (changed) {
          if (!changed) {
            try { sessionStorage.removeItem('kkReloads'); } catch (e) {}
            updateAll(cart.total_price);
            return;
          }
          return fetchCart().then(function (fresh) { lastCart = fresh; updateAll(fresh.total_price); });
        });
      })
      .catch(function () {});
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(onCartChange, 350);
  }

  /* ---------- notice cart changes from ANY script (theme, page builder, apps) ---------- */
  function isCartMutation(url) {
    return /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/.test(String(url || ''));
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url);
    var promise = nativeFetch(input, init);
    if (isCartMutation(url)) promise.then(function () { schedule(); }, function () {});
    return promise;
  };

  var xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartMutation(url)) this.addEventListener('load', function () { schedule(); });
    return xhrOpen.apply(this, arguments);
  };

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { schedule(); });
  }

  /* customer removes a GIFT line by hand: respect it for this visit (until they pick one again) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('cart-remove-button, .cart-remove-button');
    if (!btn || !lastCart) return;
    var holder = btn.closest('cart-remove-button') || btn;
    var index = parseInt(holder.dataset.index, 10);
    var item = lastCart.items[index - 1];
    if (!isGiftLine(item)) return;
    var list = declined();
    if (list.indexOf(item.variant_id) < 0) list.push(item.variant_id);
    setDeclined(list);
  }, true);

  /* customer picks an option: always (re)adds that gift, even after a manual removal */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-kk-gift-choice]');
    if (!btn || syncing) return;
    e.preventDefault();
    var id = parseInt(btn.dataset.kkGiftChoice, 10);
    var tier = parseInt(btn.dataset.kkTier, 10);
    var g = gifts.filter(function (x) { return x.threshold === tier; })[0];
    if (!g) return;
    try { localStorage.setItem('kkGiftChoice_' + tier, String(id)); } catch (err) {}
    setDeclined(declined().filter(function (d) {
      return !g.options.some(function (o) { return o.variantId === d; });
    }));
    btn.closest('.kk-cp__opts').querySelectorAll('.kk-cp__opt').forEach(function (b) { b.classList.toggle('is-on', b === btn); });
    onCartChange();
  });

  onCartChange();
})();
